import { freeze } from '@reduxjs/toolkit';
import { ISingleSelectMenuOption } from '../../Dropdown/SingleSelectMenu/types';
import { CHART_TYPES } from '../constants/chartTypes';

export const regularExpressionChartTypes = freeze<ISingleSelectMenuOption[]>(
  [
    {
      value: CHART_TYPES.LINE_CHART,
      text: 'Line',
    },
    {
      value: CHART_TYPES.BAR_CHART,
      text: 'Bar',
    },
    {
      value: CHART_TYPES.METRIC_CHART,
      text: 'Metric',
    },
  ],
  true,
);

export const chartTypesNotSupportComparison = [
  CHART_TYPES.STACKED_COLUMN_CHART,
  CHART_TYPES.PERCENT_STACKED_AREA_CHART,
  CHART_TYPES.PIE_CHART,
];

export const chartTypesRequiredBreakdown = freeze<ISingleSelectMenuOption[]>(
  [
    {
      value: CHART_TYPES.STACKED_COLUMN_CHART,
      text: 'Stacked Column',
      tooltipOption: {
        content:
          'To enable Stacked Column Visualization, please re-execute with breakdown.',
      },
    },
    {
      value: CHART_TYPES.PERCENT_STACKED_AREA_CHART,
      text: 'Percentage Area',
      tooltipOption: {
        content:
          'To enable Percentage Area Visualization, please re-execute with breakdown.',
      },
    },
    {
      value: CHART_TYPES.PIE_CHART,
      text: 'Pie',
      tooltipOption: {
        content:
          'To enable Pie Visualization, please re-execute with breakdown.',
      },
    },
  ],
  true,
);

export const regularFunnelChartTypes = freeze<ISingleSelectMenuOption[]>(
  [
    {
      value: CHART_TYPES.FUNNEL_CHART,
      text: 'Funnel',
    },
    {
      value: CHART_TYPES.COMPARATIVE_LINE_CHART,
      text: 'Comparative Line',
    },
  ],
  true,
);

export const regularRetentionChartTypes = freeze<ISingleSelectMenuOption[]>(
  [
    {
      value: CHART_TYPES.RETENTION,
      text: 'Retention',
    },
    {
      value: CHART_TYPES.RETENTION_LINE,
      text: 'Line',
    },
    {
      value: CHART_TYPES.RETENTION_BAR,
      text: 'Bar',
    },
  ],
  true,
);

export const tableChartType = freeze<ISingleSelectMenuOption>(
  {
    value: CHART_TYPES.EXPRESSION_TABLE,
    text: 'Table',
  },
  true,
);

export const geoMapChartType = freeze<ISingleSelectMenuOption>(
  {
    value: CHART_TYPES.GEO_MAP,
    text: 'Geo Map',
  },
  true,
);
